import { render, staticRenderFns } from "./myRank.vue?vue&type=template&id=3687ff74&scoped=true"
import script from "./myRank.vue?vue&type=script&lang=js"
export * from "./myRank.vue?vue&type=script&lang=js"
import style0 from "./myRank.vue?vue&type=style&index=0&id=3687ff74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687ff74",
  null
  
)

export default component.exports